import { render } from "./RegistrationHuntingData.vue?vue&type=template&id=5a1bddab&scoped=true&ts=true"
import script from "./RegistrationHuntingData.vue?vue&type=script&lang=ts"
export * from "./RegistrationHuntingData.vue?vue&type=script&lang=ts"

import "./RegistrationHuntingData.vue?vue&type=style&index=0&id=5a1bddab&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1bddab"]])

export default __exports__